<template>
  <div>
    <item-link
      v-if="row.brand_id"
      :base="base"
      basePath=""
      baseField="brand_id"
      idField="brand_id"
      nameField="brand_name"
      :rowData="row"
      displayType="tag"
      :isAllowList="false"
      class="list-sub"
      effect="plain"
      type="success"
      size="mini"
      >
    </item-link>
    <item-link
      v-if="hasSalesMode(row)"
      :base="base"
      basePath=""
      baseField="sales_mode"
      idField="sales_mode"
      nameField="sales_mode_name"
      :rowData="getSalesMode(row)"
      displayType="tag"
      :isAllowList="false"
      class="list-sub"
      effect="plain"
      type="warning"
      size="mini"
      >
    </item-link>
  </div>
</template>

<script>

import {
  BrandFieldSalesMode
} from '@/enums'

export default {
  name: 'brand-field',
  props: {
    base: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      salesMode: Object.assign({}, BrandFieldSalesMode)
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    hasSalesMode (row) {
      return (row.brand_id === 2) && row.sales_mode
    },
    getSalesMode (row) {
      let name = row.sales_mode
      if (typeof this.salesMode[row.sales_mode] !== 'undefined' &&
        this.salesMode[row.sales_mode] !== '') {
        name = this.salesMode[row.sales_mode]
      }
      return {
        sales_mode: row.sales_mode,
        sales_mode_name: name
      }
    }
  },
  watch: {
  }
}
</script>
